import TopNavComponent from "../components/TopNavComponent";
import FooterComponent from "../components/FooterComponent";
import { useEffect, useState } from 'react';
import NavModalComponent from "../components/NavModalComponent";

const NavLayout = ({children}) => {
    const [isNavActive, setIsNavActive] = useState(false);

    const toggleNav = () => {
        setIsNavActive(!isNavActive);
    }

    useEffect(() => { }, [isNavActive]);

    return (
        <div className="oveflow-x-hidden overflow-y-auto">
            {
                isNavActive &&
                <NavModalComponent toggleNav={toggleNav} />
            }
            <div className={`h-full w-full ${isNavActive ? "hidden" : ""}`}>

                <TopNavComponent toggleNav={toggleNav}  />
                {children}
                <FooterComponent />
            </div>
        </div>
    );
}

export default NavLayout;